import { queueCastWindup, tickCastWindup } from '../../domain/abilities/abilityCastTiming.js';

export function attachCastTimingHook(win) {
  if (!win) return;
  win.__debugCastWindup = () => {
    const caster = {};
    queueCastWindup(caster, { abilityKey: 'W', castTime: 0.25, effectDelay: 1.221, duration: 0 });
    const mid = tickCastWindup(caster, 0.25);
    const ready = tickCastWindup(caster, 1.221);
    return {
      blockedMid: mid === null,
      readyKey: ready?.abilityKey || null
    };
  };
}
